import { Component, forwardRef, OnInit, signal } from '@angular/core';
import { InventoryActionCreateFormComponent } from '../inventory-action-create-form.component';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Warehouse } from '../../../../../models/warehouse.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HumanPipe } from '../../../../../shared/pipes/human.pipe';
import { FormGroupPipe } from '../../../../../shared/pipes/form-group.pipe';
import { InventoryActionFormComponent } from '../../../../../shared/common-forms/inventory-action-form/inventory-action-form.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-movement-create-form',
    templateUrl: './movement-create-form.component.html',
    styleUrls: ['../inventory-action-create-form.component.scss'],
    imports: [
      AsyncPipe,
      FormGroupPipe,
      FormsModule,
      forwardRef(() => InventoryActionFormComponent),
      MatButtonModule,
      MatDialogModule,     
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatSelectModule,
      MatProgressSpinnerModule,
      MatToolbarModule,
      ReactiveFormsModule,
    ]
})
export class MovementCreateFormComponent extends InventoryActionCreateFormComponent implements OnInit{
  form = this.fb.group({
    inventory_action_products: this.fb.array([]),
    warehouse_id: [null, [Validators.required]],
    target_warehouse_id: [null, [Validators.required]],
    draft: [false],
  });

  targetWarehouses = signal<Warehouse[]>([]);

  ngOnInit(): void {
    super.ngOnInit();

    this.form.get('warehouse_id').valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef),
    )
    .subscribe((sourceWarehouseId: number) => {
      if (sourceWarehouseId) {
        this.warehouses$.subscribe((warehouses) => {
          this.targetWarehouses.set(warehouses.filter((warehouse) => warehouse.id !== sourceWarehouseId));
        });
      }
    });
  }
}
